import { Component, OnInit, ViewChild } from '@angular/core';

import { Subject, Subscription } from 'rxjs';

import { TipoProduto } from 'src/app/core/enums/produto.enum';
import { IItemProdutoRetirada } from '../../item-produto-retirada/item-produto-retirada.model';
import { TabelaInventarioComponent } from './tabela-inventario/tabela-inventario.component';
import { ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { IItemInventarioRetirada } from '../model/item-inventario-retirada.interface';

@Component({
  selector: 'app-popup-detalhe-retirada',
  templateUrl: './popup-detalhe-retirada.component.html',
  styleUrls: ['./popup-detalhe-retirada.component.css']
})
export class PopupDetalheRetiradaComponent implements OnInit {

  @ViewChild('appTabelaInventario') appTabelaInventario: TabelaInventarioComponent;
  
  // emissor: emite os lotes selecionados para a tabela ( ou quem tenha invocado o popup)
  subjectInventariosDTO: Subject<IItemInventarioRetirada[]>;
  tabelaSubscription: Subscription;
  quantidadeAMoverSubscription: Subscription;

  idUnidade: number;
  idProduto: number;

  exibirPopup = false;
  quantidadeSolicitada: number;
  quantidadeAMover: number;
  dadosLinha: IItemProdutoRetirada;
  dadosTabela: IItemProdutoRetirada[];

  // iconeProduto: {
  //   fa_icon?: string,
  //   mat_icon?: string
  // }
  // classeDoIconeTipoProduto = '';

  constructor(private toasterService: ToasterService) {
    // this.iconeProduto = {}
  }

  ngOnInit() {
  }

  show(event: any, dadosLinha: IItemProdutoRetirada, dadosTabela: IItemProdutoRetirada[], idUnidade: number): Subject<IItemInventarioRetirada[]> {
    this.idUnidade = idUnidade;
    this.exibirPopup = true;
    this.dadosLinha = dadosLinha;
    this.dadosTabela = dadosTabela;
    this.idProduto = dadosLinha.itemProdutoRetiradaPK.produto.id;
    this.quantidadeAMover = 0;
    this.quantidadeSolicitada = this.acumularQuantidadeSolicitadaPorProduto(dadosLinha.itemProdutoRetiradaPK.produto.id, dadosTabela);
    // const tipoProduto = this.getProduto(item);
    // switch ( tipoProduto ) {
    //   case TipoProduto.EQUIPAMENTO:
    //     this.iconeProduto.fa_icon = 'fa fa-stethoscope';
    //     break;
    //   case TipoProduto.MEDICAMENTO:
    //     this.iconeProduto.mat_icon = 'colorize';
    //     break;
    //   case TipoProduto.MATERIAL:
    //     this.iconeProduto.fa_icon = 'fa fa-medkit';
    //     break;
    // }

    return this.subjectInventariosDTO = new Subject();
  }

  acumularQuantidadeSolicitadaPorProduto(idProduto: number, dadosTabela: IItemProdutoRetirada[]): number {
    return dadosTabela
            .filter((item) => item.itemProdutoRetiradaPK.produto.id === idProduto)
            .reduce((total, value) => {
              return total + ( value.quantidade | 0 )
            }, 0);
  }

  hide() {
    this.exibirPopup = false;
  }

  onShow() {
    const dadosTabelaFiltradoPorProduto = this.filtrarDadosTabela(this.dadosLinha, this.dadosTabela);

    this.appTabelaInventario.inicializar(this.idUnidade, this.idProduto, dadosTabelaFiltradoPorProduto);

    this.tabelaSubscription = this.appTabelaInventario
                                  .getAplicarSubject()
                                  .subscribe(() => this.aplicar());

    this.quantidadeAMoverSubscription = this.appTabelaInventario
                                            .getQuantidadeAMoverSubject()
                                            .subscribe(
                                              quantidade => this.quantidadeAMover = quantidade 
                                            );                                
  }

  onHide() {
    if ( this.subjectInventariosDTO ) { this.subjectInventariosDTO.complete(); }
    if ( this.tabelaSubscription ) { this.tabelaSubscription.unsubscribe(); }
    if ( this.quantidadeAMoverSubscription ) { this.quantidadeAMoverSubscription.unsubscribe(); }
  }

  getProduto(dadosLinha: IItemProdutoRetirada): TipoProduto {
    return TipoProduto[dadosLinha.itemProdutoRetiradaPK.produto.tipo]
  }

  onEnter(event: any) {
    this.aplicar();
  }

  aplicar(): void {
    const itensSelecionados: IItemInventarioRetirada[] = this.appTabelaInventario.getItensSelecionados();
    
    if ( itensSelecionados.length === 0 ) {
      this.toasterService.info('Nenhum lote selecionado.');
    }
    else if ( this.quantidadeSolicitada > this.quantidadeAMover ) {
      this.toasterService.warning('Quantidade selecionada insuficiente.');
    }
    else if ( this.quantidadeAMover > this.quantidadeSolicitada ) {
      this.toasterService.warning('Quantidade selecionada maior que a solicitada.');
    }
    else {
      this.subjectInventariosDTO.next(itensSelecionados);
      this.exibirPopup = false;
    }
  }

  // aplicar() {
  //   this.appTabelaDeInventario.corrigirQuantidadeDeLotesSelecionadosNoArray();

  //   const quantidadeLotesSelecionados = this.appTabelaInventario.getQuantidadeDeLotesSelecionados();

  //   if ( quantidadeLotesSelecionados === 0 ) {
  //     this.toasterService.info('Nenhum lote selecionado.');
  //   }
  //   else if ( this.quantidadeSolicitada > this.quantidadeAMover ) {
  //     this.toasterService.warning('Quantidade selecionada insuficiente.');
  //   }
  //   else if ( this.quantidadeAMover > this.quantidadeSolicitada ) {
  //     this.toasterService.warning('Quantidade selecionada maior que a solicitada.');
  //   }
  //   else {
  //     const lotes = this.appTabelaInventario.getInventarioComLotesSelecionados();
  //     this.subject.next(lotes);
  //     this.exibirPopup = false;
  //   }
  // }

  filtrarDadosTabela(dadosLinha: IItemProdutoRetirada, dadosTabela: IItemProdutoRetirada[]): IItemProdutoRetirada[] {
    const idProdutoFiltro = dadosLinha.itemProdutoRetiradaPK.produto.id;
    
    return dadosTabela.filter(item => idProdutoFiltro === item.itemProdutoRetiradaPK.produto.id);
  }
  
}
